import { Lang } from '#~/control/index.js';
import { Sel, STag } from '#~/stag/tag.js';
import { None } from './constants.js';
import type { Props } from './types.js';
import * as Select from '@studio/design-system/select';
import { Protocol as M_Protocol, toProtocol } from '@studio/models/control';
import { useLatestFn, useLazyRef } from '@studio/react-utils/hooks';
import { type ReactElement } from 'react';

/** Video `<Protocol>` component. */
export const Protocol = ({ protocol, size, ...props }: Props): ReactElement => {
  const handleValueChange = useLatestFn((nextValue: string) => {
    const nextProtocol = nextValue !== None.value ? toProtocol(nextValue) : undefined;

    if (nextProtocol !== protocol.value) {
      protocol(nextProtocol);
    }
  });

  return (
    <Select.Root onValueChange={handleValueChange} size={size} value={protocol.value ?? None.value}>
      <Select.Trigger {...props} {...STag(Sel.ConfigVideoDeviceControl, 'protocol')}>
        <Select.Value />
      </Select.Trigger>

      <Select.Content>
        {
          useLazyRef(() => (
            <>
              {...[
                M_Protocol.ONVIF,
                M_Protocol.VISCA_IP,
                M_Protocol.HTTP
                // M_Protocol.VISCA_SERIAL
              ].map((µ) => (
                <Select.Item
                  key={µ}
                  value={µ}
                  {...STag(Sel.ConfigVideoDeviceControl, 'protocol', µ)}
                >
                  {Lang.protocol[µ]}
                </Select.Item>
              ))}
              <Select.Item
                key={None.value}
                value={None.value}
                {...STag(Sel.ConfigVideoDeviceControl, 'protocol', None.value)}
              >
                {None.label}
              </Select.Item>
            </>
          )).current
        }
      </Select.Content>
    </Select.Root>
  );
};
